export class RxjsUtils {
  public static isNotNullOrUndefined<T>(v: T | null | undefined): v is T {
    return v !== null && v !== undefined;
  }
}
